import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { featureKey } from './reducers/feature-key';
import { GenesysCloudMessageConversationEffects } from './effects/message-conversation.effects';
import { GenesysCloudMessageEffects } from './effects/message.effects';
import { GenesysCloudMessageMediaEffects } from './effects/message-media.effects';
import { genesysCloudMessageConversationsReducer } from './reducers/message-conversation.reducers';
import { GenesysCloudMessageConversationsInitializeModuleEffects } from './effects/initialize-module.effects';
import { GenesysCloudMessageDraftsEffects } from './effects/message-drafts.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(featureKey, genesysCloudMessageConversationsReducer),
    EffectsModule.forFeature([
      GenesysCloudMessageConversationsInitializeModuleEffects,
      GenesysCloudMessageConversationEffects,
      GenesysCloudMessageEffects,
      GenesysCloudMessageMediaEffects,
      GenesysCloudMessageDraftsEffects
    ])
  ]
})
export class GenesysCloudMessageConversationsModule {
}
